import { Component, inject, ChangeDetectionStrategy } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { TranslateService } from "@ngx-translate/core";
import { assertDefined } from "core/functions";

@Component({
	selector: "stages-unavailable",
	changeDetection: ChangeDetectionStrategy.Eager,
	templateUrl: "unavailable.component.html",
})
export class UnavailableComponent {
	private readonly translateService = inject(TranslateService);
	private readonly router = inject(Router);
	private readonly route = inject(ActivatedRoute);

	retry(): void {
		const redirectTo = assertDefined(this.route.snapshot.queryParamMap.get("redirectTo"));
		this.router.navigateByUrl(redirectTo);
	}

	getMessage(messageKey: string, fallbackValue: string): string {
		const message: string = this.translateService.instant(messageKey);
		if (message.includes(messageKey)) {
			return fallbackValue;
		}
		return message;
	}
}
